import React, { Component } from "react";
import Introduction from "../../components/advertisers/Introduction";
import MainContent from "../../components/advertisers/mainContent";

import "../../../assets/styles/base.css";
import "../../../assets/styles/views/containers/advertisers.css";

export default () => {
  return (
    <div>
      <Introduction />
      <MainContent />
    </div>
  );
};
